import { startTransition } from 'react';

import { DashboardUtils } from '../utils';

import Styles from './Toolbar.module.scss';

import { useActionDashboardQueryData } from '@/app/hooks/Dashboard/useActionDashboardQuery';
import { useActionDashboardWorkSheets } from '@/app/hooks/Dashboard/useActionDashboardWorkSheets';
import { useAppSelector } from '@/app/hooks/useAppSelector';
import { IconButton } from '@/components/Elements/IconButton';
import { ExportDataIcon, RefreshIcon } from '@/components/Elements/Icons';

export const Toolbar = () => {
	const filter = useAppSelector((state) => state.filter);
	const { data, isLoading, refetch } = useActionDashboardQueryData(filter);
	const [generateFile, { hasData }] = useActionDashboardWorkSheets(data);

	return (
		<div className={Styles.toolbar}>
			<button
				disabled={isLoading || !hasData}
				className={Styles.exportButton}
				onClick={() => {
					startTransition(() => {
						const create = async () => {
							const fileName = DashboardUtils.createFileName(filter);
							await generateFile(fileName);
						};

						void create();
					});
				}}
			>
				<ExportDataIcon />
				<span>Export Data</span>
			</button>
			<IconButton
				title="Refresh"
				disabled={isLoading}
				onClick={() => {
					try {
						startTransition(() => {
							void refetch?.();
						});
					} catch {
						// ignore
					}
				}}
			>
				<RefreshIcon />
			</IconButton>
		</div>
	);
};
